import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AlertService } from '../../../../services/alert-service.service';
import { Router } from '@angular/router';
import { AclService } from 'src/services/acl/acl.service';
import { AuthService } from 'src/services/auth/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  // TODO: ##implement logout api when admin logs out.

  @Output() toggleMenu = new EventEmitter();
  expand = true;
  profileImg: any = '../../../../assets/image/profile.jpg';
  dummyImg: any = '';
  name: any = '';
  openProfileMenu = false;

  constructor(
    private alert: AlertService,
    private aclService: AclService,
    private authService: AuthService,
    private router: Router) {
  }

  ngOnInit(): void {
    const width = window.innerWidth;
    if (width <= 768) {
      this.expand = false;
    }

    this.aclService.permissions
      .subscribe((permissions: { fetched: boolean, resources: any }) => {
        if (!permissions.fetched) {
          this.authService.getPermissions();
        }
      });

    this.name = localStorage.getItem('name');
  }


  toggle(): void {
    this.toggleMenu.emit(!this.expand);
    this.expand = !this.expand;
  }

  listenForClose(e: any): void {
    e.stopPropagation();
    this.openProfileMenu = !this.openProfileMenu;
    document.addEventListener('click', () => {
      this.openProfileMenu = false;
      document.removeEventListener('click', () => {
      });
    });
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/auth']);
    this.alert.showAlert('Logout Successfully', 'success');
  }
}
